import React from "react";
import analytics from "web/script/analytics/analytics";
import { RelatedProductsAreaSerializer } from "web/types/serializers";
import { gettext } from "web/script/modules/django-i18n";
import TabSwitcher from "web/react/components/tab-switcher/tab-switcher";
import RelatedProductsSection from "web/react/components/related-products-section/related-products-section";
import ProductCard from "web/react/components/product-card/react";
import styles from "./related-products-area.css";

interface RelatedProductsAreaProps extends RelatedProductsAreaSerializer {
    onOOS?: boolean;
    noAdsense?: boolean;
    noBrandAd?: boolean;
}

function RelatedProductsArea({
    sections,
    onOOS,
    noAdsense,
    noBrandAd,
}: RelatedProductsAreaProps): React.ReactElement {
    function handleTabClickAnalytics(label): void {
        if (label) {
            analytics.event("NAVIGATION", "TAB_CLICK", label);
        }
    }
    return (
        <div id="relatedproducts" className={styles.relatedProductsArea}>
            <TabSwitcher>
                <TabSwitcher.Header>
                    {sections.map(({ title, label }) => (
                        <TabSwitcher.Tab
                            key={title as string}
                            onClick={(): void => handleTabClickAnalytics(label)}
                        >
                            {title as string}
                        </TabSwitcher.Tab>
                    ))}
                </TabSwitcher.Header>

                {sections.map((section) => (
                    <RelatedProductsSection
                        key={section.label as string}
                        viewMoreUrl={section.view_more_url}
                        hiddenOnDesktop={section.hidden_products_count}
                    >
                        {section.related_products.length ? (
                            section.related_products.map((product, index) => (
                                <ProductCard key={product.id} product={product}>
                                    <ProductCard.Image
                                        width={125}
                                        height={156}
                                        lazyLoad={!(onOOS && noAdsense && noBrandAd && index < 2)}
                                    >
                                        <ProductCard.Badges />
                                    </ProductCard.Image>

                                    <ProductCard.SaveForLaterButton />

                                    <ProductCard.Details />
                                </ProductCard>
                            ))
                        ) : (
                            <p className={styles.emptyFeed}>
                                <em>{gettext("feeds.empty_message")}</em>
                            </p>
                        )}
                    </RelatedProductsSection>
                ))}
            </TabSwitcher>
        </div>
    );
}

export default RelatedProductsArea;
